function serializeTable(table) {
    if (!(table instanceof HTMLTableElement)) {
        throw new TypeError("Expected an HTMLTableElement.");
    }

    return {
        title: table.dataset.title || "",
        filename: table.dataset.filename || "",
        rows: [...table.rows].map(row => ({
            cells: [...row.cells].map(cell => ({
                value: cell.dataset.value ?? "",
                header: cell.tagName === "TH",
            })),
        })),
    };
}


export async function exportTablesToExcel(tables, filename = null) {
    // Akceptuje:
    //   exportTablesToExcel(table)
    //   exportTablesToExcel([table1, table2])
    //   exportTablesToExcel(document.querySelectorAll(...))

    if (tables instanceof HTMLTableElement) {
        tables = [tables];
    } else {
        tables = [...tables];
    }

    if (tables.length === 0) {
        throw new Error("No tables supplied for export.");
    }

    const payload = {
        tables: tables.map(serializeTable),
    };

    const response = await axios.post(
        "/export/table",
        payload,
        {
            /*headers: {
                "X-CSRFToken": getCookie("csrftoken"),
            },*/
            responseType: "blob",
        },
    );

    // Priorita:
    // 1. explicitní filename parametr
    // 2. filename z Content-Disposition
    // 3. data-filename první tabulky
    // 4. fallback
    let downloadFilename =
        filename
        || tables[0].dataset.filename
        || "export.xlsx";


    const contentDisposition = response.headers["content-disposition"];

    if (!filename && contentDisposition) {
        const utf8Match = contentDisposition.match(
            /filename\*=UTF-8''([^;]+)/
        );

        const normalMatch = contentDisposition.match(
            /filename="?([^"]+)"?/
        );

        if (utf8Match) {
            downloadFilename = decodeURIComponent(utf8Match[1]);
        } else if (normalMatch) {
            downloadFilename = normalMatch[1];
        }
    }

    if (!downloadFilename.toLowerCase().endsWith(".xlsx")) {
        downloadFilename += ".xlsx";
    }

    const url = URL.createObjectURL(response.data);

    try {
        const link = document.createElement("a");
        link.href = url;
        link.download = downloadFilename;

        document.body.appendChild(link);
        link.click();
        link.remove();
    } finally {
        URL.revokeObjectURL(url);
    }
}